var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title_txt"},[_c('a',{staticClass:"black--text del-underline",attrs:{"href":_vm.githubLink,"target":"_black"}},[_c('span',{staticClass:"mr-3"},[_vm._v(_vm._s(_vm.$t('footer.editOnGitHub')))]),_c('i',{staticClass:"icon icon-github"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }